import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CreateBlog from './components/CreateBlog';
import ContactUs from './pages/ContactUs';
import AboutPage from './pages/AboutPage';
import BlogItem from './pages/BlogItem';
import { AuthProvider, useAuth } from './context/AuthContext';
import Loading from './components/Loading';
import AuthPage from './components/auth/AuthPage';

function AppContent() {
  const { preloading ,currentUser} = useAuth();

  // Show only the loading component if preloading is true
  if (preloading) {
    return <Loading />;
  }

  // Show the rest of the app if preloading is false
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/auth" element={currentUser.isAdmin?<Navigate to={"/blogs/create"}/> : <AuthPage />} />
        <Route path="/blogs/create" element={ currentUser.isAdmin? <CreateBlog /> : <Navigate to={"/auth"} />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/:slug" element={<BlogItem />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Footer />
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;
